import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import getInvertedBorderRadius from "../../../utils/getInvertedBorderRadius";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import SurfaceOrg from "../../organisms/SurfaceOrg";
export var StyledContainer = styled(SurfaceOrg).withConfig({
  componentId: "sc-6sfbll-0"
})(function (_ref) {
  var $minHeightSpace = _ref.$minHeightSpace;
  return css(["", ""], $minHeightSpace ? css(["min-height:", ";"], space($minHeightSpace)) : null);
});
export var StyledTabsContainer = styled(FlexContainerOrg).withConfig({
  componentId: "sc-6sfbll-1"
})(function (_ref2) {
  var $backgroundColor = _ref2.$backgroundColor,
    theme = _ref2.theme;
  return css(["z-index:3;overflow:hidden;position:relative;background-color:", ";border-top-left-radius:", ";border-top-right-radius:", ";"], getColor(theme, $backgroundColor), space(2), space(2));
});
export var StyledTabContainer = styled.div.withConfig({
  componentId: "sc-6sfbll-2"
})(function (_ref3) {
  var $isActive = _ref3.$isActive,
    theme = _ref3.theme;
  return css(["position:relative;", " ", ""], $isActive ? css(["width:calc(50% + ", ");filter:drop-shadow(", ");transform:translateZ(0);"], space(2), getBoxShadow(theme, "small")) : null, !$isActive ? css(["width:calc(50% - ", ");"], space(2)) : null);
});
export var StyledTabItem = styled.div.withConfig({
  componentId: "sc-6sfbll-3"
})(function (_ref4) {
  var $isActive = _ref4.$isActive,
    $activeIndex = _ref4.$activeIndex,
    $activeBackgroundColor = _ref4.$activeBackgroundColor,
    theme = _ref4.theme;
  return css(["", ";position:relative;display:flex;flex:1;cursor:", ";justify-content:center;padding:", " ", ";", "{padding:", " ", ";}", " ", ""], transition("opacity"), $isActive ? "default" : "pointer", space(1.5), space(0), breakpoint("medium"), space(1.5), space(3), $isActive ? css(["background-color:", ";", " ", ""], getColor(theme, $activeBackgroundColor), $activeIndex === 0 ? css(["", ""], getInvertedBorderRadius("mlarge", $activeBackgroundColor, "right")) : null, $activeIndex === 1 ? css(["", ""], getInvertedBorderRadius("mlarge", $activeBackgroundColor || "background", "left")) : null) : null, !$isActive ? css(["opacity:0.7;&:hover{opacity:1;}", " ", ""], $activeIndex === 0 ? css(["padding-right:", ";", "{padding-right:", ";}"], space(2), breakpoint("medium"), space(5)) : null, $activeIndex === 1 ? css(["padding-left:", ";", "{padding-left:", ";}"], space(2), breakpoint("medium"), space(5)) : null) : null);
});
export var StyledTabHeader = styled.div.withConfig({
  componentId: "sc-6sfbll-4"
})(["display:flex;padding:", ";"], unit(1));
export var StyledContent = styled(SurfaceOrg).withConfig({
  componentId: "sc-6sfbll-5"
})(function (_ref5) {
  var $activeIndex = _ref5.$activeIndex,
    $hasAbsolutePosition = _ref5.$hasAbsolutePosition;
  return css(["z-index:2;", " ", " ", ";"], $activeIndex === 0 ? css(["border-top-left-radius:0;"]) : null, $activeIndex === 1 ? css(["border-top-right-radius:0;"]) : null, $hasAbsolutePosition ? css(["position:absolute;top:100%;left:0;right:0;"]) : null);
});